module.exports = new __parcel__URL__("grid.f0e29351.webp").toString();